module.exports = __webpack_public_path__ + "static/media/ic-facebook.1d3c5913.svg";